var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DeveloperUserProject"},[_c('ul',_vm._l((_vm.currentDeveloperProject.applications),function(application,index){return _c('li',{key:index},[_c('application-item',{attrs:{"application":application,"applicationindex":index},on:{"approveApplication":_vm.approveApplication}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }